import { useEffect, useState } from "react";
import AdminLayout from "../layout/AdminLayout";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Chip } from "@mui/material";
import agent from "../api/agent";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useNavigate, useParams, useSearchParams  } from "react-router-dom";
import { StatisticsDto } from "../models/statisticsDto";
import { formatSecondsToMMSS } from "../utils/formatSeconds";

export default function Statistics() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const urlGameType = searchParams.get("gameType");
  const campaignTitle = searchParams.get("campaignTitle");
  const [gameType, setGameType] = useState<number | null>(
    urlGameType ? parseInt(urlGameType) : null
  );
  const [statistics, setStatistics] = useState<StatisticsDto[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      agent.Games.statistics(id)
        .then(response => {
          setStatistics(response);
          if (!gameType && response[0]?.gameType) {
            setGameType(response[0].gameType);
          }
          setLoading(false);
        })
        .catch(error => {
          console.error('Failed to fetch statistics:', error);
          toast.error('Failed to fetch statistics');
          setLoading(false);
        });
    }
  }, [id]);

  const columns: GridColDef[] = gameType === 2 || gameType === 4 ? [
    {
      field: "prize",
      headerName: "Sonuç",
      width: 200,
      renderCell: (params: any) => (
        <Chip label={params.value} color={params.value === "Kazandı" ? "success" : "error"} />
      )
    },
    {
      field: "timeCompleted",
      headerName: "Süre",
      width: 200,
      renderCell: (params: any) => {
        return typeof params.value === "number" && params.value != 0
          ? formatSecondsToMMSS(params.value)
          : "";
      }
    },
    {
      field: "datePlayed",
      headerName: "Oynama Tarihi",
      width: 200,
      renderCell: (params: any) =>
        dayjs(params.value as string).add(3, 'hour').format("DD.MM.YYYY HH:mm")
    }
  ] : [
    {
      field: "prize",
      headerName: "Ödül",
      width: 200,
    },
    {
      field: "amount",
      headerName: "Dağıtılan adet",
      width: 200,
    },
    {
      field: "remainingStock",
      headerName: "Kalan stok",
      width: 200,
    },
    {
      field: "datePlayed",
      headerName: "Son Kazanıldığı Tarih",
      width: 200,
      renderCell: (params: any) =>
        params.row.amount > 0 ? (
          dayjs(params.value as string).add(3, 'hour').format("DD.MM.YYYY HH:mm")
        ) : (
          <Chip label="Henüz kazanılmadı" />
        ),
    },
  ];

  return (
    <>
      <AdminLayout title={`${campaignTitle} İstatistikleri`}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(`/campaigns/${id}?gameType=${gameType}`)}
          sx={{ mb: 2, mr: 3 }}
        >
          Kampanyaya Dön
        </Button>
        <DataGrid
          rows={statistics}
          columns={columns}
          loading={loading}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowId={(row) => `${row.prize}-${row.datePlayed}-${row.timeCompleted}`}
          pageSizeOptions={[10, 25]}
          checkboxSelection
        />
      </AdminLayout>
    </>
  );
}
